import {aiAssistantContextStore} from '@dms/ai-assistant';
import {useGetCurrentBranch} from '@dms/shared';

import {
  ASSISTANT_ENTITY_CONTEXT_LABEL_MAX_CHARACTERS,
  assistantContextSnapshotSchema,
  type AssistantContextSnapshot,
} from '@prompt-bridge/shared/ai-assistant-core';

import {useOnMount} from 'shared/web';

function PublishCurrentBranch(props: Pick<AssistantContextSnapshot, 'currentBranch'>): null {
  useOnMount(
    () => aiAssistantContextStore.patchContext({currentBranch: props.currentBranch}),
    () => aiAssistantContextStore.patchContext({currentBranch: undefined})
  );

  return null;
}

export function AiAssistantBranchSync() {
  const {activeBranchId, data: branch, isSynced} = useGetCurrentBranch();
  const parsed = assistantContextSnapshotSchema.shape.currentBranch.safeParse(
    isSynced
      ? {
          id: activeBranchId,
          label: branch?.name.slice(0, ASSISTANT_ENTITY_CONTEXT_LABEL_MAX_CHARACTERS),
        }
      : undefined
  );
  const currentBranch = parsed.success ? parsed.data : undefined;

  return <PublishCurrentBranch key={JSON.stringify(currentBranch)} currentBranch={currentBranch} />;
}
